// --------------------------------------------
// 会社（テナント）ごとの設定（SPEC-039）
//
// アクセスしたホスト名から会社を判定し、ビルド時の環境変数（process.env）を会社の値で上書きして使う。
// ビルドは1回とし、会社ごとのビルドは行わない。
// ホスト名がどの会社にも一致しない場合（localhost など）は VUE_APP_COMPANY_CD の会社とする（開発用）。
// --------------------------------------------

// 締め日: 月末締め（入力チェックの Excel を暦月で出力する）
export const CLOSING_DAY_EOM = "EOM";

// 会社ごとの設定。env はビルド時の環境変数（VUE_APP_*）を上書きする値。
const TENANTS = [
  {
    companyCd: "mykk",
    hosts: ["mydr.app.mykk.co.jp", "yummy.app.mykk.co.jp"],
    // 入力チェック Excel の締め日（前月21日〜当月20日）
    closingDay: 20,
    env: {
      VUE_APP_COMPANY_CD: "mykk",
      VUE_APP_STAFF_CD_LEN: "3",
      // タイトル・機能フラグも会社設定に持つ（git 管理外の client/.env に頼らず、どこでビルドしても同じにする）
      VUE_APP_TITLE: "My DailyReport",
      VUE_APP_USE_REP_EXCONTENT: "1",
      VUE_APP_USE_REP_EXCONTENT_CODES: "",
    },
  },
  {
    companyCd: "daiwa",
    hosts: ["diary.daiwa-hikari.com"],
    // 入力チェック Excel は暦月（1日〜月末）
    closingDay: CLOSING_DAY_EOM,
    env: {
      VUE_APP_COMPANY_CD: "daiwa",
      VUE_APP_STAFF_CD_LEN: "5",
      VUE_APP_THEME_NAME: "daiwa",
      // TODO: 旧システムのダイワ用ビルド設定（タイトル・機能フラグ）の共有後に合わせる（SPEC-039 仕様 Q4）。
      //       それまでは mykk と同じ値とする。
      VUE_APP_TITLE: "My DailyReport",
      VUE_APP_USE_REP_EXCONTENT: "1",
      VUE_APP_USE_REP_EXCONTENT_CODES: "",
    },
  },
];

/**
 * ホスト名から会社を判定する。
 * @param {string} hostname アクセスしたホスト名
 * @param {string} fallbackCompanyCd ホスト名が一致しない場合の会社コード（VUE_APP_COMPANY_CD）
 * @returns {{companyCd: string, hosts: string[], closingDay: (number|string), env: object}} 会社の設定
 */
export function resolveTenant(hostname, fallbackCompanyCd) {
  const host = (hostname || "").toLowerCase();
  const byHost = TENANTS.find((t) => t.hosts.includes(host));
  if (byHost) {
    return byHost;
  }
  const cd = (fallbackCompanyCd || "").trim().toLowerCase();
  const byCd = TENANTS.find((t) => t.companyCd === cd);
  if (byCd) {
    return byCd;
  }
  // 設定に無い会社（開発用）。締め日・桁数は mykk と同じ既定値とする。
  return { companyCd: cd, hosts: [], closingDay: 20, env: { VUE_APP_COMPANY_CD: cd } };
}

// 現在の会社
export const currentTenant = resolveTenant(
  typeof window !== "undefined" ? window.location.hostname : "",
  process.env.VUE_APP_COMPANY_CD
);

// ビルド時の環境変数を会社の値で上書きしたもの（window.app.env として参照する）
export const appEnv = Object.freeze(Object.assign({}, process.env, currentTenant.env));

export default currentTenant;
